import React from 'react';
import { Link } from 'react-router-dom';
import { WhatsAppIcon } from './Icons';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-section">
          <div className="footer-logos-container">
            <img src="/full-logodark.png" alt="Neha Shuttering Logo" className="footer-logo" />
            <img src="/deslogodark.png" alt="Design Logo" className="footer-deslogo" />
          </div>
          <p>Providing high-quality shuttering and scaffolding solutions for the construction industry.</p>
          <div className="social-links">
            <a
              href="https://wa.me/919911949911?text=Namaste%2C%20main%20aapse%20judna%20chahta%20hoon%20is%20baare%20mein%20aur%20jaankari%20lene%20ke%20liye."
              className="social-icon"
              aria-label="WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsAppIcon fill="currentColor" />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/products">Our Products</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Details</h4>
          <p>Email: info@nehashuttering.com</p>
          <p>Phone: +91 9811949911 / 9810664832</p>
          <p>WhatsApp: +91 9911949911</p>
          <p>Hours: Mon - Sat: 9:00 AM - 7:00 PM</p>
        </div>

        <div className="footer-section">
          <h4>Business Address</h4>
          <p>Khewat No.592, Khata No.755, Killa No.8221, Shaheed Major Vikash Yadav Marg, Near NH-8, Jharsa Chowk, Gurgaon-122001 (HR)</p>

          <div className="mini-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3507.9456747201466!2d77.03907407549418!3d28.451053975764424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDI3JzAzLjgiTiA3N8KwMDInMjkuOSJF!5e0!3m2!1sen!2sin!4v1787774757259!5m2!1sen!2sin" width="100%"
              height="220"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              title="Neha Shuttering Location"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Neha Shuttering. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;